import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extracts a bare GitHub handle from a value that may be a full URL
 * (https://github.com/foo/), a bare handle, or prefixed with "@".
 */
export function githubHandle(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim().replace(/\/+$/, '');
  const segment = trimmed.split('/').pop() ?? '';
  const handle = segment.replace(/^@/, '').toLowerCase();
  return handle || null;
}
